@if (cmSelected$(); as cm) {
  <app-cm-selected [cmSelected]="cm" (unselectCMEvent)="unselectCM()"></app-cm-selected>
} @else {
  <app-cm-list (cmSelectedEvent)="selectCM($event)"></app-cm-list>
}
